import { j as P } from "./jsx-runtime-3tyXYecC.mjs";
import { useState as Q, useRef as q, useImperativeHandle as B } from "react";
import { _ as G } from "./composeRefs-YONvD-rx.mjs";
import { F as L } from "./file-upload-qEEuC7RE.mjs";
import { a as O } from "./add-rhf-default-error-message-C9MkLfg3.mjs";
import { g as T } from "./get-aria-describedby-G1wcWKF2.mjs";
import { u as V } from "./use-rhf-wrapper-controller-DGFm3TD5.mjs";
import { t as W } from "./toggle-rhf-rules-Z1TdwfO9.mjs";
import { e as k } from "./extract-rhf-validation-rule-value-DyB3XAHu.mjs";
import { c as i } from "./combine-function-calls-C5qD-ZYI.mjs";
const l = {
  required: window.jQuery ? $._("Please upload a file") : "Please upload a file",
  uploadError: window.jQuery ? $._("Please try uploading again") : "Please try uploading again"
}, z = (r) => typeof r == "string" ? {
  message: r || l.required,
  value: !0
} : O(r, l.required);
function ae({
  apiRef: r,
  ariaDescribedby: E,
  control: y,
  defaultValue: n = [],
  disabled: u,
  errorMessageId: f,
  name: d,
  onChange: p,
  onError: H,
  onFileSelected: U,
  onRemove: m,
  required: o = !1,
  shouldUnregister: h,
  status: v,
  validate: _,
  ...b
}) {
  var F;
  const [j, c] = Q(!1), { field: x, fieldState: a } = V({
    control: y,
    defaultValue: n,
    name: d,
    rules: W({ required: z(o), validate: _ }, u),
    shouldUnregister: h
  }), { onBlur: D, onChange: g, ref: S, value: R } = x, t = q();
  B(
    r,
    () => ({
      focus: () => {
        var e;
        (e = t.current) == null || e.focus();
      }
    }),
    [t]
  );
  const w = () => {
    c(!0);
  }, C = (e) => {
    const s = R.filter((M) => M.id !== e.id);
    typeof m == "function" && m(e), i(g, p)(s);
  }, A = (e) => {
    const s = [...R, e];
    c(!1), i(g, p)(s);
  };
  return /* @__PURE__ */ P.jsx(
    L,
    {
      ...b,
      ariaDescribedby: T(a.error ? f : void 0, E),
      errorMessage: f ? void 0 : ((F = a.error) == null ? void 0 : F.message) || l.uploadError,
      initialFiles: n,
      isDisabled: u,
      isRequired: typeof o == "string" ? !!o : k(o),
      name: d,
      onBlur: D,
      onChange: U,
      onError: i(H, w),
      onRemove: C,
      onUpload: A,
      status: a.error || j ? "error" : v,
      toggleRef: G(S, t)
    }
  );
}
export {
  ae as F
};
//# sourceMappingURL=file-upload-rhf-0rfVXLla.mjs.map
